'use strict';
var parent = require('../../stable/instance/reverse');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/reverse.js
// module id = 536
// module chunks = 13